export const SET_GEOLOCATION = "SET_GEOLOCATION";
